import { useTheme } from "../../../context/ThemeProvider";
import { FaBirthdayCake } from "react-icons/fa";
import globalStyles from "../../../styles/globalStyles.module.css";
import {
  FaDroplet,
  FaCookie,
  FaTree,
  FaFire,
  FaSun,
  FaMoon,
} from "react-icons/fa6";

const themes = [
  {
    key: "lightMode",
    icon: <FaSun color="#112d4e" />,
    backgroundColor: "#dbe2ef",
  },
  {
    key: "darkMode",
    icon: <FaMoon color="#00adb5" />,
    backgroundColor: "#393e46",
  },
  {
    key: "pinkMode",
    icon: <FaBirthdayCake color="#F9F9E0" />,
    backgroundColor: "#FF90BC",
  },
  {
    key: "blueMode",
    icon: <FaDroplet color="#0f4c75" />,
    backgroundColor: "#3282b8",
  },
  {
    key: "brownMode",
    icon: <FaCookie color="#815b5b" />,
    backgroundColor: "#9e7676",
  },
  {
    key: "redMode",
    icon: <FaFire color="#e23e57" />,
    backgroundColor: "#88304e",
  },
  {
    key: "greenMode",
    icon: <FaTree color="#183d3d" />,
    backgroundColor: "#5c8374",
  },
];

const ThemeSelector = () => {
  const { setTheme } = useTheme();

  return (
    <>
      {themes.map(({ key, icon, backgroundColor }) => (
        <button
          key={key}
          onClick={() => setTheme(key)}
          className={globalStyles.button}
          style={{
            backgroundColor,
            border: "none",
            width: "40px",
            height: "40px",
          }}
        >
          {icon}
        </button>
      ))}
    </>
  );
};

export default ThemeSelector;
